module.exports = __webpack_public_path__ + "img/login.8944f3bd.png";